import { IRemoteTrack } from '..';
import { createDecorator } from '../plugin';

export function changeRemoteTrackState() {
  return createDecorator(subscribe => function (...remoteTracks: IRemoteTrack[]) {
    const promise = subscribe.apply(this, remoteTracks);
    remoteTracks.forEach(remoteTrack => !remoteTrack.isSubscribed && remoteTrack.subscribe(promise));
    return promise;
  });
}
